// AJAX Request

let tileGrids = document.getElementsByClassName('tile-grid-js');

function loadTiles() {


    for(let tileGrid of tileGrids) {
        requestPosts(tileGrid);
    }

    function requestPosts(tileGrid) {
        let maxAmount = tileGrid.dataset.amount - 1;
        let postType = tileGrid.dataset.type;
        let postOrder = tileGrid.dataset.order;
        let excludedPost = tileGrid.dataset.exclude;
        let currentGrid = tileGrid;
        let tileGridLength = tileGrid.getElementsByClassName('tile').length;


        // REQUEST ALL POSTS
        var ourRequest = new XMLHttpRequest();
        ourRequest.open('GET', nextNetzData.root_url + '/wp-json/wp/v2/' + postType + '?_embed&per_page=100' + '&exclude=' + excludedPost + '&acf_format=standard');
        ourRequest.onload = function() {
            if (ourRequest.status >= 200 && ourRequest.status < 400) {
                var postsData = JSON.parse(ourRequest.responseText);
                console.log(postsData.length);

                // Sort Post Data
                postsData.sort((a, b) => a.acf.datum - b.acf.datum);
                postsData.reverse()

                // Veranstaltungen finden, die in der Vergangenheit liegen
                if(postType == 'veranstaltung') {
                    Date.prototype.yyyymmdd = function() {
                        var mm = this.getMonth() + 1; // getMonth() is zero-based
                        var dd = this.getDate();
                        
                        return [this.getFullYear(),
                                (mm>9 ? '' : '0') + mm,
                                (dd>9 ? '' : '0') + dd
                                ].join('');
                    };
                      
                    var date = new Date();
                    let dateYmd = date.yyyymmdd();

                    // Sort Post Data
                    postsData.sort((a, b) => a.acf.datum - b.acf.datum);

                    postsData.reverse()
                    let splicePosition
                    for(let i = 0; i < postsData.length; i++) {
                        if (postsData[i].acf.datum >= dateYmd) {
                            splicePosition = i + 1
                        }                     
                    }
            
                    postsData.splice(0, splicePosition);
                 //   tileGridLength++
                }

                //check if posts exist, that are not already being displayed

                if(postsData.length > tileGridLength) {
                    postsData.splice(0, tileGridLength)
                    createButton(postsData, tileGrid)
                } else {
                    return
                }
            } else {
                console.log("We connected to the server, but it returned an error.");
            }
        };

        ourRequest.onerror = function() {
            console.log("Connection error");
        };

        ourRequest.send();
    }


    function createButton(postsData, tileGrid, postType) {
        // Create Button with unique ID
        let buttonId = Math.random()
        let button = `<div style="margin-top: 2rem; display:flex; justify-content:center;"><button id="${buttonId}">Weitere Beiträge laden</button></div>`
        tileGrid.insertAdjacentHTML("afterend", button)
        
        // Add Eventlistener-Click on Button
        document.addEventListener("click", function(e) {
            if(e.target.id == buttonId) {
                createHTML(postsData, tileGrid)
                e.target.remove();
            }
        })
    }


    // Add HTML to Page
    async function createHTML(postsData, currentGrid) {
        // add maximum of three Tiles
        let runtime
        let postsToLoad = 3
        if(postsData.length >= postsToLoad) {
                 runtime = postsToLoad 
        } else {
                 runtime = postsData.length;
        }

        // create HTML
        let htmlString = '';
        
        // loop through posts
        for(let i = 0; i < runtime; i++ ) {

            let vernetzung = postsData[0].acf.vernetzung[0]?.post_title
            let altText = postsData[0].acf.stock_image?.alt;

            // Datum Darstellung ändern
            let months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
            let day = postsData[0].acf.datum.slice(6,8);
            let monthNumber = postsData[0].acf.datum.slice(4,6);
            // if(monthNumber.slice(0,1) == 0) {
            //     monthNumber = monthNumber.slice(1, 2)
            // }
            // let month = months[monthNumber - 1] + ' '
            let year =  postsData[0].acf.datum.slice(0, 4)
            
            // create HTML
            if(postsData[0].type != 'veranstaltung') {
                htmlString += `<div class="tile yellow equal-height">
                    <div class="text-wrap">
                        <div class="tile-top">
                            <span class="date-small">${day + '.' + monthNumber  + '.' + year}</span>
                            <a href="${postsData[0].link}">
                                <h3>${postsData[0].title.rendered}</h3>
                            </a>
                            <p>${postsData[0].acf.kurzbeschreibung}</p>
                        </div>
                        ${vernetzung ? '<span class="meta-translate">' + vernetzung + '</span>' : ''}
                    </div>
                </div>`
            } else {
             
                let image = postsData[0].acf.stock_image.sizes.large;

                htmlString += `<div class="tile blue equal-height">
                <div class="date-header">
                    <span class="date-small">${day + '.' + monthNumber  + '.' + year}</span>
                </div>
                <img src="${image}" alt="${altText}">
                    <div class="text-wrap">
                            <div class="tile-top">
                            <a href="${postsData[0].link}">
                                <h3>${postsData[0].title.rendered}</h3>
                            </a> 
                        </div>
                        ${vernetzung ? '<span class="meta-translate">' + vernetzung + '</span>' : ''}
                        <?php endif; ?>
                    </div>
                </div>`
            }

            // Delte Item from Array
            postsData.splice(0, 1)
        }

        

        // Add HTML to DOM
        currentGrid.insertAdjacentHTML("beforeend", htmlString);
        
        // Display Button again if posts are left
        if(postsData.length > 0) {
            createButton(postsData, currentGrid);
        } else {
            return
        }
    }
}

loadTiles();